module.exports = __webpack_public_path__ + "static/media/Agro-Dealer infographic  mobile 22-02-2024 C.fccf0ccb.gif";